export { default } from './ReplacementProductsCarousel'
